import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserRegistrationApiService } from '@thehubz/client/data-access-api';
import { EMPTY, catchError, map, switchMap } from 'rxjs';

@Component({
  selector: 'lh-confirm-email',
  templateUrl: './confirm-email.component.html',
  styleUrls: ['./confirm-email.component.scss'],
})
export class ConfirmEmailComponent implements OnInit {
  token = '';
  logoUrl!: string;
  loading = true;
  errorMessage = '';

  constructor(private readonly activatedRoute: ActivatedRoute, private readonly userRegistrationApiService: UserRegistrationApiService) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams
      .pipe(
        map((params) => params['token']),
        switchMap((token) =>
          this.userRegistrationApiService.userRegistrationControllerConfirmEmailAddress({
            token,
          }),
        ),
        catchError((err) => {
          this.loading = false;
          this.errorMessage = err.error.message;
          return EMPTY;
        }),
      )
      .subscribe({
        next: () => {
          this.loading = false;
        },
      });

    this.logoUrl = 'assets/logos/brand-logo.svg';
  }
}
